/* Item simulator — SVG のパーツごとに色を変える。
   設定はセクションが埋め込む JSON（data-psim-config）から読む。 */
(function () {
  "use strict";

  var SHAPES = "path,circle,rect,ellipse,polygon,polyline,line";

  function normFill(v) {
    var f = String(v || "")
      .trim()
      .toLowerCase();
    if (f === "#fff" || f === "#ffffff") return "white";
    if (f === "#000" || f === "#000000") return "black";
    return f;
  }

  // パーツは <path id> でも <g id> でもよい。g の場合は
  // 「ボディ色の図形」だけを塗り替え対象にして、輪郭パスは残す。
  function markFillTargets(el, bodyFill) {
    var kids = el.matches(SHAPES)
      ? [el]
      : Array.prototype.slice.call(el.querySelectorAll(SHAPES));
    var targets = kids.filter(function (k) {
      var f = normFill(k.getAttribute("fill"));
      return !f || f === bodyFill;
    });
    if (!targets.length) {
      var first = kids.filter(function (k) {
        return normFill(k.getAttribute("fill")) !== "none";
      })[0];
      targets = first ? [first] : [];
    }
    targets.forEach(function (k) {
      k.setAttribute("data-fillable", "");
    });
  }

  function fillTargets(host) {
    return host.hasAttribute("data-fillable")
      ? [host]
      : Array.prototype.slice.call(host.querySelectorAll("[data-fillable]"));
  }

  function Simulator(root) {
    var config;
    try {
      config = JSON.parse(root.querySelector("[data-psim-config]").textContent);
    } catch (e) {
      return;
    }
    var ITEMS = config.items || {};
    var COLORS = config.colors || [];
    var DEFAULT_COLOR = config.defaultColor || (COLORS[0] || {}).value || "#000";
    var ids = Object.keys(ITEMS);
    if (!ids.length || !COLORS.length) return;

    var $ = function (ref) {
      return root.querySelector('[data-psim="' + ref + '"]');
    };
    var stage = $("stage");
    var state = { item: ids[0], colors: {}, sel: null };
    var cache = {};
    var loading = {};
    var thumbCache = {};

    var item = function () {
      return ITEMS[state.item];
    };
    var colorsOf = function (id) {
      return state.colors[id] || (state.colors[id] = {});
    };
    var colorOf = function (partId) {
      return colorsOf(state.item)[partId] || DEFAULT_COLOR;
    };

    // ---------- SVG の読み込み ----------
    function buildNode(id, text) {
      var wrap = document.createElement("div");
      wrap.innerHTML = text;
      var node = wrap.querySelector("svg");
      if (!node) return null;
      node.removeAttribute("width");
      node.removeAttribute("height");
      node.setAttribute("preserveAspectRatio", "xMidYMid meet");
      node.setAttribute("focusable", "false");
      var paintable = {};
      (ITEMS[id].parts || []).forEach(function (p) {
        paintable[p.id] = true;
      });
      var locked = ITEMS[id].locked || [];
      var bodyFill = normFill(ITEMS[id].bodyFill || "white");
      Array.prototype.forEach.call(node.querySelectorAll("[id]"), function (el) {
        if (paintable[el.id]) {
          el.setAttribute("data-paint", el.id);
          markFillTargets(el, bodyFill);
        } else if (locked.indexOf(el.id) !== -1) {
          el.setAttribute("data-locked", "");
        }
      });
      node.addEventListener("pointerdown", function (e) {
        var hit = e.target.closest("[data-paint]");
        if (!hit) return;
        e.preventDefault();
        e.stopPropagation();
        select(hit.getAttribute("data-paint"), e);
      });
      cache[id] = node;
      return node;
    }

    function loadItem(id) {
      if (cache[id]) return Promise.resolve(cache[id]);
      if (loading[id]) return loading[id];
      loading[id] = fetch(ITEMS[id].src)
        .then(function (r) {
          if (!r.ok) throw new Error(ITEMS[id].src + ": " + r.status);
          return r.text();
        })
        .then(function (text) {
          return buildNode(id, text);
        })
        .catch(function (err) {
          console.error(err);
          return null;
        });
      return loading[id];
    }

    function thumbNode(id) {
      if (thumbCache[id]) return thumbCache[id];
      var base = cache[id];
      if (!base) return null;
      var node = base.cloneNode(true);
      // 一覧のサムネはキャンバスの色に追従させず、既定色で固定する
      (ITEMS[id].parts || []).forEach(function (p) {
        var host = node.querySelector('[data-paint="' + p.id + '"]');
        if (host)
          fillTargets(host).forEach(function (t) {
            t.setAttribute("fill", DEFAULT_COLOR);
          });
      });
      thumbCache[id] = node;
      return node;
    }

    // ---------- 塗り ----------
    function paintPart(partId, value) {
      Array.prototype.forEach.call(
        stage.querySelectorAll('[data-paint="' + partId + '"]'),
        function (host) {
          fillTargets(host).forEach(function (t) {
            t.setAttribute("fill", value);
          });
        },
      );
    }

    function applyColors() {
      (item().parts || []).forEach(function (p) {
        paintPart(p.id, colorOf(p.id));
      });
    }

    function uniformColor() {
      var list = (item().parts || []).map(function (p) {
        return colorOf(p.id);
      });
      return list.every(function (v) {
        return v === list[0];
      })
        ? list[0]
        : null;
    }

    function setColor(partId, value) {
      colorsOf(state.item)[partId] = value;
      paintPart(partId, value);
      renderSwatches($("swatches"), onSidePick, uniformColor());
    }

    function setAllColors(value) {
      (item().parts || []).forEach(function (p) {
        colorsOf(state.item)[p.id] = value;
        paintPart(p.id, value);
      });
      renderSwatches($("swatches"), onSidePick, uniformColor());
    }

    function onSidePick(c) {
      setAllColors(c.value);
    }

    // ---------- 描画 ----------
    function renderSwatches(host, onPick, current) {
      if (!host) return;
      host.innerHTML = "";
      COLORS.forEach(function (c) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "psim-swatch" + (current === c.value ? " is-on" : "");
        b.style.background = c.value;
        b.title = c.code ? c.name + "（" + c.code + "）" : c.name;
        b.setAttribute("aria-label", b.title);
        b.addEventListener("click", function (e) {
          onPick(c, e);
        });
        host.appendChild(b);
      });
    }

    function renderItems() {
      var box = $("items");
      if (!box) return;
      box.innerHTML = "";
      ids.forEach(function (id) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "psim-item" + (id === state.item ? " is-active" : "");
        b.innerHTML =
          '<span class="psim-thumb"></span>' +
          '<span class="psim-item-name"><span>' +
          ITEMS[id].name +
          "</span>" +
          (ITEMS[id].code
            ? '<span class="psim-item-code">' + ITEMS[id].code + "</span>"
            : "") +
          "</span>";
        b.addEventListener("click", function () {
          if (state.item === id) return;
          state.item = id;
          state.sel = null;
          paint();
        });
        var th = thumbNode(id);
        if (th) b.querySelector(".psim-thumb").appendChild(th);
        box.appendChild(b);
      });
    }

    // ---------- 選択とポップオーバー ----------
    function closePop() {
      var pop = root.querySelector(".psim-pop");
      if (pop) pop.remove();
    }

    function clearSelection() {
      state.sel = null;
      closePop();
    }

    function select(partId, e) {
      state.sel = partId;
      closePop();
      var pop = document.createElement("div");
      pop.className = "psim-pop";
      pop.innerHTML =
        '<div class="psim-pop-head"><span>' +
        (config.pickLabel || "カラーを選択する") +
        '</span><button type="button" class="psim-pop-close" aria-label="閉じる">×</button></div>' +
        '<div class="psim-swatches"></div>';
      pop.querySelector(".psim-pop-close").addEventListener("click", function () {
        clearSelection();
      });
      renderSwatches(
        pop.querySelector(".psim-swatches"),
        function (c) {
          setColor(partId, c.value);
          clearSelection(); // 色を選んだら閉じる
        },
        colorOf(partId),
      );
      stage.appendChild(pop);
      placePop(pop, e);
    }

    function placePop(pop, e) {
      var box = stage.getBoundingClientRect();
      var w = pop.offsetWidth || 214;
      var h = pop.offsetHeight || 90;
      var x = box.width / 2 - w / 2;
      var y = box.height / 2 - h / 2;
      if (e) {
        x = e.clientX - box.left + 14;
        y = e.clientY - box.top - h / 2;
      }
      pop.style.left = Math.max(8, Math.min(box.width - w - 8, x)) + "px";
      pop.style.top = Math.max(8, Math.min(box.height - h - 8, y)) + "px";
    }

    function paint() {
      closePop();
      stage.innerHTML = "";
      renderSwatches($("swatches"), onSidePick, uniformColor());
      var id = state.item;
      var mount = function (node) {
        if (state.item !== id) return; // 読み込み中に切り替わった場合
        stage.innerHTML = "";
        if (!node) {
          var msg = document.createElement("p");
          msg.className = "psim-hint";
          msg.textContent = "SVG を読み込めませんでした";
          stage.appendChild(msg);
          return;
        }
        stage.appendChild(node);
        renderItems();
        applyColors();
      };
      if (cache[id]) mount(cache[id]);
      else loadItem(id).then(mount);
    }

    var reset = $("reset");
    if (reset)
      reset.addEventListener("click", function () {
        state.colors[state.item] = {};
        state.sel = null;
        paint();
      });

    stage.addEventListener("pointerdown", function (e) {
      if (e.target.closest(".psim-pop")) return;
      if (e.target.closest("[data-paint]")) return;
      clearSelection();
    });

    paint();
    root.__psim = { state: state, paint: paint, setColor: setColor };
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-psim-root]"), Simulator);
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();
})();
